import React from 'react';
import PropTypes from 'prop-types';
import DoorCharts from './components/charts/DoorCharts.jsx';
import configuration from './assets/storm_configuration.png';
import handing from './assets/storm_handing.png';
import StormDoorMeasures from './components/measures/StormDoorMeasures.jsx';
import LaborMaterial from './components/LaborMaterial.jsx';
import Comments from './components/Comments.jsx';
import ProjectNeeds from './components/ProjectNeeds.jsx';
import HomeDiagram from './components/HomeDiagram';
import ProductTemplate from './components/ProductTemplate';

function StormDoorTemplate({
  data,
  onChange,
  permitRequired,
  onPermitRequiredChange,
  onReadStart,
  onReadEnd,
}) {
  const {
    measures = { storm_doors: [] },
    labors_materials = [],
    comments = '',
    needs = {},
    home_diagram = {},
    product_template = {},
  } = data;

  return (
    <div>
      <h4>Storm Door Worksheet</h4>
      <DoorCharts
        configurationChart={configuration}
        handingChart={handing}
        configAlt="Storm Door Configuration Chart"
        handingAlt="Storm Door Handing Chart"
      />
      <StormDoorMeasures
        measures={measures.storm_doors}
        onChange={updatedMeasures => onChange(
          { ...data, measures: { ...data.measures, storm_doors: updatedMeasures } },
        )}
      />
      <LaborMaterial
        labors_materials={labors_materials}
        onChange={updatedLaborsMaterials => onChange(
          { ...data, labors_materials: updatedLaborsMaterials },
        )}
      />
      <Comments
        comments={comments}
        onChange={updatedComments => onChange(
          { ...data, comments: updatedComments },
        )}
      />
      <ProjectNeeds
        needs={needs}
        onChange={updatedNeeds => onChange({ ...data, needs: updatedNeeds })}
        permitRequired={permitRequired}
        onPermitRequiredChange={onPermitRequiredChange}
      />
      <HomeDiagram
        home_diagram={home_diagram}
        onChange={updatedHomeDiagram => onChange(
          { ...data, home_diagram: updatedHomeDiagram },
        )}
        onReadStart={onReadStart}
        onReadEnd={onReadEnd}
      />
      <ProductTemplate
        product_template={product_template}
        onChange={updatedProductTemplate => onChange(
          { ...data, product_template: updatedProductTemplate },
        )}
        onReadStart={onReadStart}
        onReadEnd={onReadEnd}
      />
    </div>
  );
}

StormDoorTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  permitRequired: PropTypes.bool,
  onPermitRequiredChange: PropTypes.func,
  onReadStart: PropTypes.func,
  onReadEnd: PropTypes.func,
};

export default StormDoorTemplate;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/StormDoorTemplate.jsx